import React from "react";
import { Tabs, TabsProps } from "antd";
import { MainBreadCrumbs } from "../Common/MainBreadCrumbs";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "../Context/ThemeContext";
import AddItems from "../Pages/Purchase/AddItems";
// import AddCategoryModel from "../Pages/Expenses&income/AddCategoryModel";
import AssetModel from "../Pages/Assets/AssetModel";
import DisposedAssestNewModal from "../Pages/Assets/DisposedAssestNewModal";
import { useClient } from "../Context/ClientContext";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../Pages/Users/UserSecurityFind";
import { useUser } from "../../Context/UserContext";
import { IAccessSettings } from "../../Types";
import { ISilderName } from "../Common/PageRoute";
import { SettingsSections } from "../Services/SettingService";
import { IPermissionActionType } from "../Pages/Users/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../Context/RoleContext";
// import DisposeAssetmodel from "../Pages/Assets/DisposeAssetmodel";

interface IProps {
  element: JSX.Element;
  silderName: ISilderName;
  breadcrumprops: {
    item?: string | null;
    path?: string;
  }[];
  menuprops: {
    showData: string;
    addButton?: string;
  }[];
}

const SalesInvoiceTemplate = (props: IProps) => {
  const navigate = useNavigate();
  const { accessSettings } = useUser();
  const themeData: any = useTheme();
  const location = useLocation();
  const [tabBreadCrumb, setTabBreadCrumb] = React.useState("");
  const [color, setColor] = React.useState(false);
  const changeColor = () => {
    if (window.scrollY >= 90) {
      setColor(true);
    } else {
      setColor(false);
    }
  };
  window.addEventListener("scroll", changeColor);
  const { companySettings, currentClient } = useClient();
  const { clientSpecificRole } = useUser();
  const [locationUrl, setLocationUrl] = React.useState<string>("");
  const [trigger, setTrigger] = React.useState<boolean>(false);
  const [width, setWidth] = React.useState<any>(window.innerWidth);
  const [itemTableTrigger, setItemTableTrigger] =
    React.useState<boolean>(false);
  const [open, setOpen] = React.useState(false);
  const [openItemModel, setOpenItemModel] = React.useState<any>({
    type: "",
    param: {},
  });
  React.useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  React.useEffect(() => {
    let splittedpath = location.pathname.split("/");
    let salesurl = splittedpath[splittedpath.length - 1];
    setLocationUrl(salesurl);
    let breadKey = salesurl.charAt(0).toUpperCase() + salesurl.slice(1);
    setTabBreadCrumb(breadKey);
  }, [location]);

  const onChange = (key: string) => {
    navigate(key);
  };

  //  const keyconvertor = (item: string) => {
  //     if (item === "Proforma Invoices") {
  //       return "proformaInvoices";
  //     } else if (item === "Credit Notes") {
  //       return "creditNotes";
  //     } else if (item === "Debit Note") {
  //       return "debitNote";
  //     } else if (item === "Purchase Bill") {
  //       return "purchaseBill";
  //     } else if (item === "Purchase Out") {
  //       return "purchaseOut";
  //     } else if (item === "Purchase Order") {
  //       return "order";
  //     } else if (item === "Sales Order") {
  //       return "order";
  //     } else if (item === "Payment Out") {
  //       return "paymentOut";
  //     } else if (item === "Delivery Challan") {
  //       return "deliveryChallan";
  //     } else if (item === "Fixed Assets") {
  //       return "fixedAsset";
  //     } else if (item === "Share Capital") {
  //       return "sharecapital";
  //     } else if (item === "Bank Accounts") {
  //       return "bankAccounts";
  //     } else if (item === "Cash In Hand") {
  //       return "cashInHand";
  //     } else if (item === "Loan Accounts") {
  //       return "loanAccounts";
  //     } else if (item === "Aged Debtors") {
  //       return "debtors";
  //     } else if (item === "Aged Creditors") {
  //       return "creditors";
  //     } else if (item === "Bank Reconciliation") {
  //       return "bankReconciliation";
  //     } else if (item === "Item Group") {
  //       return "itemGroup";
  //     } else if (item === "Company Info") {
  //       return "companyInfo";
  //     } else if (item === "Payment Term") {
  //       return "paymentTerm";
  //     } else if (item === "Opening Balance") {
  //       return "openingBalance";
  //     } else if (item === "Default Ledger") {
  //       return "defaultLedger";
  //     } else if (item === "Terms And Conditions") {
  //       return "termsandConditions";
  //     } else if (item === "Item Groups") {
  //       return "itemgroups";
  //     } else if (item === "Item Category") {
  //       return "itemCategory";
  //     } else if (item === "Item Locations") {
  //       return "itemlocations";
  //     } else if (item === "Testing") {
  //       return "testing";
  //     } else if (item === "Parties Group") {
  //       return "partiesGroup";
  //     } else if (item === "Expenses Group") {
  //       return "expensesGroup";
  //     } else if (item === "Income Group") {
  //       return "incomeGroup";
  //     } else if (item === "Expenses Ledger") {
  //       return "expensesLedger";
  //     } else if (item === "Income Ledger") {
  //       return "incomeLedger";
  //     } else {
  //       return item.trim().toLowerCase();
  //     }
  //   };

  const keyMap: { [key: string]: string } = {
    "Parties Group": "partiesGroup",

    "Item Group": "itemGroup",
    "Item Groups": "itemgroups",
    "Item Category": "itemCategory",
    "Item Locations": "itemlocations",

    "Proforma Invoices": "proformaInvoices",
    "Credit Notes": "creditNotes",
    "Sales Order": "order",

    "Purchase Bill": "purchaseBill",
    "Debit Note": "debitNote",
    "Purchase Out": "purchaseOut",
    "Purchase Order": "order",
    "Payment Out": "paymentOut",
    "Delivery Challan": "deliveryChallan",

    "Expenses Group": "expensesGroup",
    "Expenses Ledger": "expensesLedger",

    "Income Group": "incomeGroup",
    "Income Ledger": "incomeLedger",

    "Bank Accounts": "bankAccounts",
    "Cash In Hand": "cashInHand",
    "Loan Accounts": "loanAccounts",
    "Bank Reconciliation": "bankReconciliation",

    "Fixed Assets": "fixedAsset",
    "Share Capital": "sharecapital",

    "Aged Debtors": "debtors",
    "Aged Creditors": "creditors",

    "Company Info": "companyInfo",
    "Payment Term": "paymentTerm",
    "Opening Balance": "openingBalance",
    "Default Ledger": "defaultLedger",
    "Terms And Conditions": "termsandConditions",
    "Lock Month": "lockmonth",

    "Sub Units": "subunits",
  };

  const keyconvertor = (item: string): string => {
    return keyMap[item] ?? item.trim().toLowerCase();
  };

  const createMenuItem = (
    item: { showData: string; addButton: string },
    onChange: (key: string) => void,
    isEnabled: boolean
  ) => {
    const key = keyconvertor(item?.showData);
    const label = (
      <div>
        {item?.showData && (
          <span style={{ padding: "0px 14px" }} onClick={() => onChange(key)}>
            <span>{item?.showData}</span>
          </span>
        )}
      </div>
    );
    return isEnabled ? { key, label } : false;
  };

  // Company setting
  const conditionHandlersCompanySetting: Record<
    string,
    (item: any) => boolean
  > = {
    // Setting tab
    "Company Info": () =>
      findUserPremission(
        [
          "Setting.Company.Info.View",
          "Setting.Company.Details.View",
          "Setting.Company.PaymentTerm.View",
          "Setting.Company.GST.View",
        ],
        clientSpecificRole(),
        currentClient?.id!
      ),
    Vouchers: () =>
      findUserPremission(
        [
          "Setting.Voucher.Sales.View",
          "Setting.Voucher.ProformaInvoice.View",
          "Setting.Voucher.CreditNote.View",
          "Setting.Voucher.Receipt.View",
          "Setting.Voucher.Estimate.View",
          "Setting.Voucher.SalesOrder.View",

          "Setting.Voucher.Bill.View",
          "Setting.Voucher.DebitNote.View",
          "Setting.Voucher.PaymentOut.View",
          "Setting.Voucher.PurchaseOrder.View",

          "Setting.Voucher.Expenses.View",
          "Setting.Voucher.Income.View",

          "Setting.Voucher.Contra.View",
          "Setting.Voucher.Journal.View",
          "Setting.Voucher.FixedAsset.View",
        ],
        clientSpecificRole(),
        currentClient?.id!,
        [
          SettingsSections.Invoice,
          SettingsSections.PInvoice,
          SettingsSections.CrNote,
          SettingsSections.Receipt,
          SettingsSections.Quotation,
          SettingsSections.SOrder,

          // Purchase
          SettingsSections.PurInvoice,
          SettingsSections.DrNote,
          SettingsSections.Payment,
          SettingsSections.POrder,

          // expenses & income
          SettingsSections.Expenses,
          SettingsSections.Income,

          // Journal
          SettingsSections.Journal,
          // Contra
          SettingsSections.Contra,
          // Asset
          SettingsSections.Asset,
        ],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    Items: () =>
      findUserPremission(
        ["Setting.Item.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Opening Balance": () =>
      findUserPremission(
        ["Setting.OpeningBalance.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
    Templates: () =>
      findUserPremission(
        ["Setting.Templates.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Default Ledger": () =>
      findUserPremission(
        ["Setting.DefaultLedger.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Terms And Conditions": () =>
      findUserPremission(
        [
          "Setting.TC.Sales.View",
          "Setting.TC.ProformaInvoice.View",
          "Setting.TC.CreditNote.View",
          "Setting.TC.Receipt.View",
          "Setting.TC.Estimate.View",
          "Setting.TC.SalesOrder.View",
          "Setting.TC.Bill.View",
          "Setting.TC.DebitNote.View",
          "Setting.TC.PaymentOut.View",
          "Setting.TC.PurchaseOrder.View",
          "Setting.TC.Expenses.View",
          "Setting.TC.Income.View",
          "Setting.TC.Contra.View",
          "Setting.TC.Journal.View",
          "Setting.TC.FixedAsset.View",
        ],
        clientSpecificRole(),
        currentClient?.id!,
        [
          SettingsSections.Invoice,
          SettingsSections.PInvoice,
          SettingsSections.CrNote,
          SettingsSections.Receipt,
          SettingsSections.Quotation,
          SettingsSections.SOrder,

          // Purchase
          SettingsSections.PurInvoice,
          SettingsSections.DrNote,
          SettingsSections.Payment,
          SettingsSections.POrder,

          // expenses & income
          SettingsSections.Expenses,
          SettingsSections.Income,

          // Journal
          SettingsSections.Journal,
          // Contra
          SettingsSections.Contra,
          // Asset
          SettingsSections.Asset,
        ],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.TandC],
        }
      ),
    TDS: () =>
      currentClient?.tdsDeductible === true
        ? findUserPremission(
            ["Setting.TDS.View"],
            clientSpecificRole(),
            currentClient?.id!
          )
        : false,

    //   true &&
    // findUserSettingAccessSecurity(useAccessSettingsData, Setting_Type.TDS) === true

    TCS: () =>
      currentClient?.tcsApplicability === true
        ? findUserPremission(
            ["Setting.TCS.View"],
            clientSpecificRole(),
            currentClient?.id!
          )
        : false,
    // //   true &&
    // // findUserSettingAccessSecurity(useAccessSettingsData, Setting_Type.TDS) === true
    Email: () =>
      findUserPremission(
        ["Setting.Email.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
    Currencies: () =>
      findUserPremission(
        ["Setting.Currencies.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
    // Lock Month
    "Lock Month": () =>
      findUserPremission(
        ["Setting.LockMonth.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
  };

  // Party tab
  const conditionHandlersParty: Record<string, (item: any) => boolean> = {
    Parties: () =>
      findUserOnlyOnePremission(
        "Master.Ledger.Party.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Parties Group": () =>
      findUserOnlyOnePremission(
        "Master.Group.Party.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
  };

  // Item tab
  const conditionHandlersItem: Record<string, (item: any) => boolean> = {
    Items: () =>
      findUserOnlyOnePremission(
        "Master.Item.View",
        clientSpecificRole(),
        currentClient?.id!
      ) === true,
    "Item Category": () =>
      companySettings?.setting?.item?.maintainCategory === true
        ? findUserOnlyOnePremission(
            "Master.Item.Category.View",
            clientSpecificRole(),
            currentClient?.id!
          )
        : false,
    Units: () =>
      findUserOnlyOnePremission(
        "Master.Item.Unit.View",
        clientSpecificRole(),
        currentClient?.id!
      ) === true,
    "Item Locations": () =>
      companySettings?.setting?.item?.maintainItemLocation
        ? findUserOnlyOnePremission(
            "Master.Item.Locations.View",
            clientSpecificRole(),
            currentClient?.id!
          )
        : false,
  };

  // Sales tab
  const conditionHandlersSales: Record<string, (item: any) => boolean> = {
    Invoices: () =>
      findUserPremission(
        ["Voucher.Sales.Invoice.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Invoice],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Proforma Invoices": () =>
      findUserPremission(
        ["Voucher.Sales.ProformaInvoice.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.PInvoice],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Credit Notes": () =>
      findUserPremission(
        ["Voucher.Sales.CreditNote.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.CrNote],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    Receipts: () =>
      findUserPremission(
        ["Voucher.Sales.Receipt.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Receipt],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    Estimate: () =>
      findUserPremission(
        ["Voucher.Sales.Estimate.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Quotation],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Sales Order": () =>
      findUserPremission(
        ["Voucher.Sales.SalesOrder.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.SOrder],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    Customer: () =>
      findUserPremission(
        ["Master.Ledger.Customer.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
  };

  // Purchase tab
  const conditionHandlersPurchase: Record<string, (item: any) => boolean> = {
    "Purchase Bill": () =>
      findUserPremission(
        ["Voucher.Purchase.Bill.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.PurInvoice],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Debit Note": () =>
      findUserPremission(
        ["Voucher.Purchase.DebitNote.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.DrNote],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Payment Out": () =>
      findUserPremission(
        ["Voucher.Purchase.PaymentOut.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Payment],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Purchase Order": () =>
      findUserPremission(
        ["Voucher.Purchase.PurchaseOrder.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.POrder],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    Suppliers: () =>
      findUserOnlyOnePremission(
        "Master.Ledger.Suppliers.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
  };

  // Expenses & Income tab
  const conditionHandlersExpensesAndIncome: Record<
    string,
    (item: any) => boolean
  > = {
    Expenses: () =>
      findUserPremission(
        ["Voucher.Expenses.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Expenses],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Expenses Ledger": () =>
      findUserOnlyOnePremission(
        "Master.Ledger.Expenses.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Expenses Group": () =>
      findUserOnlyOnePremission(
        "Master.Group.Expenses.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    Income: () =>
      findUserPremission(
        ["Voucher.Income.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Income],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Income Ledger": () =>
      findUserOnlyOnePremission(
        "Master.Ledger.Income.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Income Group": () =>
      findUserOnlyOnePremission(
        "Master.Group.Income.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
  };

  // Banking (Cash & Bank)
  const conditionHandlersBanking: Record<string, (item: any) => boolean> = {
    "Bank Accounts": () =>
      findUserPremission(
        ["Voucher.Contra.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Contra],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Cash In Hand": () =>
      findUserPremission(
        ["Voucher.Contra.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Contra],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Bank Reconciliation": () =>
      findUserOnlyOnePremission(
        "Master.BankReconciliation.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    Cheque: () =>
      findUserOnlyOnePremission(
        "Master.Cheque.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Loan Accounts": () =>
      findUserOnlyOnePremission(
        "Voucher.LoanAccount.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
  };

  // Fixed Assets tab
  const conditionHandlersFixedAssets: Record<string, (item: any) => boolean> = {
    "Fixed Assets": () =>
      findUserPremission(
        ["Voucher.Asset.FixedAsset.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Asset],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    Disposed: () =>
      findUserOnlyOnePremission(
        "Voucher.Asset.DisposedAsset.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    Location: () =>
      findUserOnlyOnePremission(
        "Master.AssestsLocation.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
  };

  // Master tab
  const conditionHandlersMaster: Record<string, (item: any) => boolean> = {
    Ledger: () =>
      findUserOnlyOnePremission(
        "Master.Ledger.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    Group: () =>
      findUserOnlyOnePremission(
        "Master.Group.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    // findUserOnlyOnePremission(
    //   "Master.Group.View",
    //   clientSpecificRole(),
    //   currentClient?.id!
    // ),
  };

  // Items tab
  const items: TabsProps["items"] | any = props.menuprops?.map((item: any) => {
    let isConditionMet;
    console.log("data", item?.showData);
    switch (props?.silderName) {
      case ISilderName.Party:
        isConditionMet = conditionHandlersParty[item?.showData]?.(item);
        break;
      case ISilderName.Item:
        isConditionMet = conditionHandlersItem[item?.showData]?.(item);
        break;
      case ISilderName.Sales:
        isConditionMet = conditionHandlersSales[item?.showData]?.(item);
        break;
      case ISilderName.Purchase:
        isConditionMet = conditionHandlersPurchase[item?.showData]?.(item);
        break;
      case ISilderName.Expenses:
        isConditionMet =
          conditionHandlersExpensesAndIncome[item?.showData]?.(item);
        break;
      case ISilderName.Banking:
        isConditionMet = conditionHandlersBanking[item?.showData]?.(item);
        break;
      case ISilderName.FixedAsset:
        isConditionMet = conditionHandlersFixedAssets[item?.showData]?.(item);
        break;
      case ISilderName.Master:
        isConditionMet = conditionHandlersMaster[item?.showData]?.(item);
        break;
      case ISilderName.Settings:
        isConditionMet =
          conditionHandlersCompanySetting[item?.showData]?.(item);
        break;
      case ISilderName.Organisations:
        isConditionMet =
          conditionHandlersCompanySetting[item?.showData]?.(item);
        break;
    }

    // const isConditionMet = conditionHandlers[item?.showData]?.(item);
    console.log("isConditionMet", props.silderName, isConditionMet);

    if (isConditionMet !== undefined) {
      return createMenuItem(item, onChange, isConditionMet);
    }

    // Default case
    return {
      key: keyconvertor(item?.showData),
      label: (
        <div>
          {item?.showData && (
            <span
              style={{ padding: "0px 14px" }}
              onClick={() => onChange(keyconvertor(item.showData))}
            >
              <span>{item?.showData}</span>
            </span>
          )}
        </div>
      ),
      children: "",
    };
  });

  return (
    <>
      <MainBreadCrumbs
        breadCrumbItems={[...props.breadcrumprops, { item: tabBreadCrumb }]}
      />
      {width <= 768 ? (
        <Tabs
          size="small"
          className="Tabs-Responsive customTab"
          onChange={onChange}
          type="card"
          items={items}
        />
      ) : (
        locationUrl !== "" && (
          <Tabs
            activeKey={locationUrl}
            defaultActiveKey={locationUrl}
            items={items}
            className="ca-header-tab"
            tabBarGutter={11}
            tabBarStyle={{
              // backgroundColor: "#f5f8ff",
              // backgroundColor: "white",
              backgroundColor: "rgb(247, 248, 250)",
              position: "fixed",
              height: "32px",
              boxShadow: color ? "1px 2px 5px 4px red" : "",
              fontFamily: "'Open Sans','sans-serif'",
              fontWeight: 500,
              borderRadius: "6px",
              // marginLeft: "38px",
              // width:
              //   width <= 1024
              //     ? "91%"
              //     : themeData?.themeData?.silderSize
              //     ? "83%"
              //     : "calc(100vw - 100px)",
              width: "100%",
              // marginTop: "8px",
              // marginTop: "20px",
              zIndex: 5,
            }}
          />
        )
      )}
      <div>
        <div
          style={{
            // padding: "10px 20px 0px 20px",
            padding: "10px 15px 0px",
            // margin: width <= 768 ? "-20px 0px 0px 0px" : "40px 0px 0px 0px",
            margin: width <= 768 ? "-20px 0px 0px 0px" : "1px 0px 0px ",
            overflowY: "auto",
            // height: `calc(100vh - 112px)`,
            height: `calc(100vh - 74px)`,
            // backgroundColor: themeData?.themeData?.darkMode ? "" : "white",
            backgroundColor: themeData?.themeData?.darkMode ? "" : "#f7f8fa",
          }}
        >
          {props.element}
        </div>
      </div>
      {/*--------------- Add Items Props --------------- */}
      {openItemModel.type === "addItem" && (
        <AddItems
          open={openItemModel?.param.open}
          onCancel={() => setOpenItemModel({ type: "", param: {} })}
          setTrigger={setTrigger}
          itemPage={openItemModel?.param.itemType}
        />
      )}
      {/* {openItemModel.type === "addCategory" && (
        <AddCategoryModel
          isModalOpen={openItemModel?.param.open}
          setIsModalOpen={() => setOpenItemModel({ type: "", param: {} })}
          editCategory={{ id: null }}
        />
      )} */}
      {openItemModel.type === "addFixedAsset" && (
        <AssetModel
        // isModalOpen={openItemModel?.param.open}
        // setIsModalOpen={() => setOpenItemModel({ type: "", param: {} })}
        // editAsset={{ id: null }}
        // isConfirmation={false}
        // modelCancel={function (): void {
        //   throw new Error("Function not implemented.");
        // }}
        // setIsConfirmation={function (
        //   value: React.SetStateAction<boolean>
        // ): void {
        //   throw new Error("Function not implemented.");
        // }}
        // setTrigger={function (value: React.SetStateAction<boolean>): void {
        //   throw new Error("Function not implemented.");
        // }}
        />
      )}
      {openItemModel.type === "addDisposed" && (
        <DisposedAssestNewModal
          setReRender={setTrigger}
          reRender={trigger}
          isDisposeOpen={openItemModel?.param.open}
          setIsDisposeOpen={() => setOpenItemModel({ type: "", param: {} })}
        />
      )}
    </>
  );
};

export default SalesInvoiceTemplate;
